import _ from 'lodash';

function Vehicle(data) {
    if (data) {
        _.extend(this, data);
    }
}

Vehicle.prototype.getYearMakeNameML = function () {
    let name = this.year || '';
    if (this.make && typeof this.make === 'string') {
        if (name) {
            name += ' ';
        }
        name += this.make;
    }

    if (name.length < 1) {
        name = 'Unnamed';
    }

    return name;
};

Vehicle.prototype.getModelNameML = function () {
    let name = '';
    if (this.model && typeof this.model === 'string') {
        name += this.model;
    }

    return name;
};

Vehicle.prototype.getTrimNameML = function () {
    let name = '';
    if (this.trim_ML && typeof this.trim_ML === 'string') {
        name += this.trim_ML;
    }

    return name;
};

Vehicle.prototype.getYearMakeModelNameML = function () {
    let name = this.year || '';

    if (this.make && typeof this.make === 'string') {
        if (name) {
            name += ' ';
        }
        name += this.make;
    }
    if (this.model && typeof this.model === 'string') {
        if (name) {
            name += ' ';
        }
        name += this.model;
    }

    if (name.length < 1) {
        name = 'Unnamed';
    }

    return name;
};

Vehicle.prototype.getFixedId = function () {
    return this.fixedId;
};

export default Vehicle;
